<template>
	<div class="animated fadeIn">
		<div class="row pageinfo">
			<b-col lg="6">
				<!--Display Trash or Normal Table View-->
				<h2>Price - {{this.subTitle}}</h2>
			</b-col>
			<b-col lg="6">			
				<b-dropdown :disabled="edit" class="pull-right" right variant="info" no-caret>
					<template slot="button-content">
						<i class="fa fa-cog"></i>
					</template>
					<b-dropdown-item @click="editTdg()">Edit</b-dropdown-item>
					<b-dropdown-item @click="deleteTdg()">Delete</b-dropdown-item>
				</b-dropdown>
			</b-col>
		</div>

		<div>
			<b-card v-if="loadingData">
				<b-col cols="12" sm="12" md="12" lg="12">
					<p class="text-center">
						<i class="fa fa-refresh fa-lg mt-4 fa-spin"></i><br>Loading data...
					</p>
				</b-col>
			</b-card>
			<div v-else>
				<b-card v-if="found">
					    <b-row>
                            <b-col md="8">
                                <b-form-group v-if="!edit" :label-cols="4" id="L1" horizontal label="Month Year" label-for="Tdg1">
                                        <b-form-input id="Tdg1" v-if="!edit" class="plaintext-input" plaintext type="text" v-model="model.month_year"></b-form-input>                               
                                </b-form-group> 
                                <b-form-group v-else :label-cols="4" id="L1" horizontal label="Month Year" label-for="Tdg1">
                                        <b-form-select :disabled="months.length==0"  value-field="id" text-field="name" id="Tdg11" v-model="model.month" :options="months" />
                                        <b-form-select :disabled="years.length==0"   value-field="id" text-field="name" id="Tdg111" v-model="model.year" :options="years" />
                                </b-form-group>
                             </b-col>
                        </b-row>
						<b-row>
							<b-col md="8">

                                <b-form-group :label-cols="4" id="L2" label="Exchange Rate" label-for="Tdg2" horizontal>
                                    <b-form-input id="Tdg2" v-if="!edit" class="plaintext-input" plaintext type="text" v-model="model.exchange_rate"></b-form-input>
                                    <b-form-input id="Tdg2" v-else type="text" v-model="model.exchange_rate" autocomplete="off" @keydown.native="myOnlyNumber($event, 'exchange_rate')" @blur.native="inputBlur('exchange_rate')"></b-form-input>
                                </b-form-group>

                                <b-form-group :label-cols="4" id="L3" label="WTI" label-for="Tdg3" horizontal>
                                    <b-form-input id="Tdg3" v-if="!edit" class="plaintext-input" plaintext type="text" v-model="model.wti"></b-form-input>
                                     <b-form-input id="Tdg3" v-else type="text" v-model="model.wti" autocomplete="off"  @keydown.native="myOnlyNumber($event, 'wti')" @blur.native="inputBlur('wti')"></b-form-input>
                                </b-form-group>

                                <b-form-group :label-cols="4" id="L4" label="WCS" label-for="Tdg4" horizontal>
                                    <b-form-input id="Tdg4" v-if="!edit" class="plaintext-input" plaintext type="text" v-model="model.wcs" ></b-form-input>
                                    <b-form-input id="Tdg4" v-else type="text" v-model="model.wcs" autocomplete="off" @keydown.native="myOnlyNumber($event, 'wcs')" @blur.native="inputBlur('wcs')"></b-form-input>
                                </b-form-group>

                                <b-form-group :label-cols="4" id="L5" label="LLK" label-for="Tdg5" horizontal>
                                    <b-form-input id="Tdg5" v-if="!edit" class="plaintext-input" plaintext type="text" v-model="model.llk" ></b-form-input>
                                    <b-form-input id="Tdg5" v-else type="text" v-model="model.llk" autocomplete="off" @keydown.native="myOnlyNumber($event, 'llk')" @blur.native="inputBlur('llk')"></b-form-input>
                                </b-form-group>

                                <b-form-group :label-cols="4" id="L6" label="LLB" label-for="Tdg6" horizontal>
                                    <b-form-input id="Tdg6" v-if="!edit" class="plaintext-input" plaintext type="text" v-model="model.llb"></b-form-input>
                                    <b-form-input id="Tdg6" v-else type="text" v-model="model.llb" autocomplete="off" @keydown.native="myOnlyNumber($event, 'llb')" @blur.native="inputBlur('llb')"></b-form-input>
                                </b-form-group> 

                                <b-form-group :label-cols="4" id="L7" label="C5" label-for="Tdg7" horizontal>
                                    <b-form-input id="Tdg7" v-if="!edit" class="plaintext-input" plaintext type="text" v-model="model.c5"></b-form-input>
                                    <b-form-input id="Tdg7" v-else type="text" v-model="model.c5" autocomplete="off" @keydown.native="myOnlyNumber($event, 'c5')" @blur.native="inputBlur('c5')"></b-form-input>
                                </b-form-group>

                                <b-form-group :label-cols="4" id="L8" label="AECO" label-for="Tdg8" horizontal>
                                    <b-form-input id="Tdg8" v-if="!edit" class="plaintext-input" plaintext type="text" v-model="model.aeco"></b-form-input>
                                    <b-form-input id="Tdg8" v-else type="text" v-model="model.aeco" autocomplete="off" @keydown.native="myOnlyNumber($event, 'aeco')" @blur.native="inputBlur('aeco')"></b-form-input>
                                </b-form-group>

                                <b-form-group :label-cols="4" id="L9" label="Placeholder 1" label-for="Tdg9" horizontal>
                                    <b-form-input id="Tdg9" v-if="!edit" class="plaintext-input" plaintext type="text" v-model="model.placeholder_1"></b-form-input>
                                    <b-form-input id="Tdg9" v-else type="text" v-model="model.placeholder_1" autocomplete="off" @keydown.native="myOnlyNumber($event, 'placeholder_1')" @blur.native="inputBlur('placeholder_1')"></b-form-input>
                                </b-form-group>

                                <b-form-group :label-cols="4" id="L10" label="Placeholder 2" label-for="Tdg10" horizontal>
                                    <b-form-input id="Tdg10" v-if="!edit" class="plaintext-input" plaintext type="text" v-model="model.placeholder_2" autocomplete="off" @keydown.native="myOnlyNumber($event, 'placeholder_2')" @blur.native="inputBlur('placeholder_2')"></b-form-input>
                                    <b-form-input id="Tdg10" v-else type="text" v-model="model.placeholder_2"></b-form-input>
                                </b-form-group>

								<b-form-group :label-cols="4" id="L12" horizontal label="Type" label-for="Tdg12">
									<b-form-input id="Tdg12" v-if="!edit" type="text" v-model="model.invoice_type_name" class="plaintext-input" plaintext></b-form-input>
									<b-form-select v-else :disabled="invoice_types.length==0" value-field="id" text-field="name" id="Tdg12" v-model="model.invoice_type_id" :options="invoice_types">
									<template slot="first"><option :value="null" disabled>-- select type --</option></template>
									</b-form-select>
								</b-form-group> 

								<div slot="footer" v-show="edit">
									<b-button @click="update()" size="sm" variant="primary"><i class="fa fa-edit"></i> Update</b-button>
									<b-button @click="editTdg()" size="sm"><i class="fa fa-ban"></i> Cancel</b-button>
								</div>
							</b-col>
						</b-row>
					<!-- </b-tab> -->
				</b-card>
				<b-row v-else>
					<b-col cols="12" sm="12" md="12" lg="12">
						<br>
						<p class="text-center text-danger">
							<i class="icon fa-lg icon-puzzle"></i><br>{{notFoundMessage}}
						</p>
					</b-col>
				</b-row>
			</div>
		</div>
	</div>
</template>

<script>
	import iprice_service from './invoices_service'
	export default {
		name: 'InvoicePrice',
		created: function() {
			this.getCompanyData()
		},
		props: {
			id: {
				type: String,
				default: 0
			}
		},
		data() {
			return {
				subTitle        : '',
				edit            : false,
				found           : false,
				notFoundMessage : 'Not found',
                model       : {
                        exchange_rate   : '',    
                        wti             : '',             
                        wcs             : '',            
                        llk             : '',           
                        llb             : '',          
                        c5              : '',       
                        aeco            : '',      
                        placeholder_1   : '',
                        placeholder_2   : '',
                        month           :1,
                        year            :2021,
                        month_year      : '',
						invoice_type_id : null,   
                },
				updateData      : null,
				originalData    : null,
				loadingData     : true,
				                years         : [
                { 'id':2023, 'name':'2023'}, 
                { 'id':2022, 'name':'2022'},
                { 'id':2021, 'name':'2021'}, 
                { 'id':2019, 'name':'2020'},
                { 'id':2018, 'name':'2019'}, 
                ],
                months         : [
                { 'id':1, 'name':'January'}, 
                { 'id':2, 'name':'Frebuary'},
                { 'id':3, 'name':'March'}, 
                { 'id':4, 'name':'April'},
                { 'id':5, 'name':'May'}, 
                { 'id':6, 'name':'Jun'},
                { 'id':7, 'name':'July'}, 
                { 'id':8, 'name':'August'},
                { 'id':9, 'name':'September'}, 
                { 'id':10, 'name':'October'},
                { 'id':11, 'name':'November'}, 
                { 'id':12, 'name':'December'},
                ],
				invoice_types : [],
			}
		},
		methods: {
			editTdg() {
				if (this.edit) {
					this.edit = false
					this.restoreOriginalData()
				} else {
					this.edit = true
				}
			},
			restoreOriginalData() {
				let model = {
					...this.originalData,
				}
				this.model = model
			},
			getCompanyData() {
				iprice_service.getBy_iprice(this.id)
					.then(data => {
						if (data.status == 'success') {
							this.originalData   = data.invoice_price
							this.invoice_types=data.invoice_types
                            console.log(this.originalData)
                            //this.fluidtypeselect  = data.fluid_types					
							this.companyId      = this.id
							this.loadingData    = false
							this.found          = true
							this.restoreOriginalData()							
							this.subTitle       = this.companyId
						}else {
                            this.$swal(data.status, data.message, data.status)
                            this.loadingData = false
                            return

                        }
					})
					.catch(error => {
						this.$swal('Error', 'Server not response. ' + error, 'error')
						this.loadingData = false
					})
			},
			okToUpdate() {
            if (this.model.placeholder_1 === undefined || this.model.placeholder_1.trim().length == 0) {
                this.$swal('Alert!', 'Placeholder 1 can not be empty', 'warning')
                return false
            }
            if (this.model.placeholder_2 === undefined || this.model.placeholder_2.trim().length == 0) {
                this.$swal('Alert!', 'Placeholder 2 can not be empty', 'warning')
                return false
            }
            if (this.model.aeco === undefined || this.model.aeco.trim().length == 0) {
                this.$swal('Alert!', 'AECO can not be empty', 'warning')
                return false
            }
            if (this.model.c5  === undefined || this.model.c5.trim().length == 0) {
                this.$swal('Alert!', 'C5 can not be empty', 'warning')
                return false
            }
            if (this.model.llb === undefined || this.model.llb.trim().length == 0) {
                this.$swal('Alert!', 'LLB can not be empty', 'warning')
                return false
            }
            if (this.model.llk === undefined || this.model.llk.trim().length == 0) {
                this.$swal('Alert!', 'LLK can not be empty', 'warning')
                return false
            }
            if (this.model.wcs === undefined || this.model.wcs.trim().length == 0) {
                this.$swal('Alert!', 'WCS can not be empty', 'warning')
                return false
            }
            if (this.model.wti === undefined || this.model.wti.trim().length == 0) {
                this.$swal('Alert!', 'WTI can not be empty', 'warning')
                return false
            }
            if (this.model.exchange_rate === undefined || this.model.exchange_rate.trim().length == 0) {
                this.$swal('Alert!', 'Exchange Rate can not be empty', 'warning')
                return false
            }
			if (this.model.invoice_type_id === undefined || this.model.invoice_type_id === null) {
                this.$swal('Alert!', 'Select Type', 'warning')
                return false
            }
				return true
			},
            update () {
                if (!this.okToUpdate()) {
					return
				}
                console.log(this.model)
				iprice_service.update_iprice (this.companyId, this.model)
					.then((data) => {
						this.$swal(data.status, data.message, data.status)
							.then((result) => {
								this.getCompanyData()
							})
					})
					.catch(error => {
						this.$swal('Error', 'Server not response. ' + error, 'error')
					})
					this.edit=false
			},
			deleteTdg() {
				this.$swal({
					title: 'Please, confirm',
					text: "Are you sure to delete this Invoice Price: " + this.model.month_year + " ?",
					type: 'question',
					showCancelButton: true,
					confirmButtonColor: '#3085d6',
					cancelButtonColor: '#d33',
					confirmButtonText: 'Yes',
					reverseButtons: true
				}).then((result) => {
					if (result.value) {
						iprice_service.delete_iprice(this.companyId)
							.then(data => {
								this.$swal(data.status, data.message, data.status)
								if (data.status == 'success') {
									this.$router.replace('/invoice_prices')
								}
							})
							.catch(error => {
								this.$swal('Error', 'Server not response. ' + error, 'error')
							})
					}
				})
			},
			inputBlur(variableName) {
          let variableValue = this.model[variableName]
          if (variableValue.length == 0) {

              this.model[variableName] = "0.00000"
            
          } else {
            if (variableValue.length == 1 && variableValue.indexOf("-")!=-1) {

              this.model[variableName] = "0.00000"
              return
            
            }
            let tempValue = variableValue.split(".")
            if (tempValue.length == 1) {

                    this.model[variableName] = String(variableValue) + ".00000"
                      
            } else if (tempValue.length == 2) {

                    this.model[variableName] = String(tempValue[0]) + "." + (String(tempValue[1]) + "00000").slice(0, 5)
                
            }
          }
        },
        myOnlyNumber(evt, variableName) {
            let dotPosition = this.model[variableName].indexOf(".")
            let hasDot = dotPosition > -1
            let length = this.model[variableName].length
            this.isNumber(evt, hasDot, dotPosition, length, 5)
            
        },
        isNumber: function(evt, hasDot, dotPosition, length, n_digit) {

          evt = (evt) ? evt : window.event;
          var charCode = (evt.which) ? evt.which : evt.keyCode;
          if (charCode <= 31 || charCode === 189 || charCode == 37 || charCode == 39 || (charCode >= 96 && charCode <= 105) || ((charCode >= 48 && charCode <= 57) || charCode === 46 || charCode === 19 || (!hasDot && charCode == 190)|| (!hasDot && charCode == 110))) {
            let selectionStart = evt.target.selectionStart;
            let selectionEnd = evt.target.selectionEnd;
            if ((hasDot && (selectionEnd > dotPosition && selectionStart > dotPosition && selectionEnd == selectionStart) && length -  n_digit> dotPosition) && charCode > 31 && (charCode != 37 && charCode != 39)) {
                evt.preventDefault();
            } else {
              if (charCode==189) {
                if (length!=0) {
                    evt.preventDefault();
                }
                else {
                    return true
                }                  
              } else {
                  return true
              }
            }
          } else {
            evt.preventDefault();
          }
        },
		}
	}
</script>



// WEBPACK FOOTER //
// src/views/invoices/invoice_price.vue